import { render, staticRenderFns } from "./createProduto.vue?vue&type=template&id=500b6e6f&scoped=true"
import script from "./createProduto.vue?vue&type=script&lang=js"
export * from "./createProduto.vue?vue&type=script&lang=js"
import style0 from "./createProduto.vue?vue&type=style&index=0&id=500b6e6f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "500b6e6f",
  null
  
)

export default component.exports